import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther } from "viem";
import chinaAbi from "../../utils/chinaAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const usePurchaseEth = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const purchaseEth = useCallback(
    async (min, amount, postApiRes, id, balance, stakeIndex, index, insurancePer) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      let nd;
      if (index) {
        const percent = parseFloat(amount) * insurancePer;
        const value = parseFloat(amount) + percent;
        const fixed = Math.round(parseFloat(value).toFixed(6) * 1e12) / 1e12;
        nd = parseEther(fixed.toString());
      } else {
        const fixed = Math.round(parseFloat(amount).toFixed(6) * 1e12) / 1e12;
        nd = parseEther(fixed.toString());
      }

      let minvalue = min * 0.99;
      minvalue = Math.round(parseFloat(minvalue).toFixed(6) * 1e12) / 1e12;
      minvalue = parseEther(minvalue.toString());

      console.log(nd, postApiRes.code, id, postApiRes.deadline, minvalue, "purchaseEth params");

      try {
        const hash = await writeContractAsync({
          address: Environment.presaleContract,
          abi: chinaAbi,
          functionName: "purchaseTokenWithETH",
          args: [
            postApiRes.code,
            id,
            postApiRes.deadline,
            minvalue,
            postApiRes?.agentsAddresses,
            postApiRes?.agentsPercentages,
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
          value: nd,
        });

        console.log("PurchaseEth tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("PurchaseEth confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("PurchaseEth error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseEth };
};

export default usePurchaseEth;
